import { ValiError } from 'valibot';

import { API } from '@/api';
import { fetcher, HTTPError, logger } from '@/services/fetcher';

import { type PortTypeFiltersUpdateApi, portTypesApiSchema } from '../../models';

const masterDataApi = fetcher.extend(() => ({ prefixUrl: `${API.MASTER_DATA_PUBLIC}` }));

export const fetchPortTypes = async (
  filters: PortTypeFiltersUpdateApi,
  { signal }: { signal?: AbortController['signal'] } = {},
) => {
  try {
    return await masterDataApi.get('lookup-code/QTPORTTP', { searchParams: filters, signal }).json(portTypesApiSchema);
  } catch (error) {
    if (error instanceof ValiError || (error instanceof Error && error.name === 'ValiError')) {
      logger.warn('Validation error on port types response', (error as ValiError<typeof portTypesApiSchema>).issues);
    }
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
